import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text, EmptyState } from 'modules/common';

function Gallery({ options, onChange, activeIndex, label, emptyStateProps }) {
  const handleOnClick = (index) => {
    onChange(index);
  };

  return (
    <div className="flex flex-col gap-ds-16">
      <Text weight="semibold" type="subheading" color="primitive-white">
        {label}
      </Text>

      {options?.length > 0 ? (
        <div className="grid grid-cols-3 gap-ds-8 md:gap-ds-16">
          {options?.map((item, key) => (
            <button
              type="button"
              className={cn(
                'w-full text-left aspect-h-11 aspect-w-16 md:aspect-h-9 md:aspect-w-16 rounded',
                {
                  'ring-2 ring-default gallery-active': activeIndex === key,
                }
              )}
              onClick={() => handleOnClick(key)}
              // eslint-disable-next-line react/no-array-index-key
              key={key}
            >
              <img
                src={item?.url}
                className="object-cover h-full w-full rounded"
                alt="gallery-lightbox"
              />
            </button>
          ))}
        </div>
      ) : (
        <EmptyState
          titleTextProps={{
            color: 'primitive-white',
          }}
          descriptionTextProps={{
            color: 'primitive-white',
          }}
          {...emptyStateProps}
        />
      )}
    </div>
  );
}

Gallery.defaultProps = {
  options: [],
  onChange: () => {},
  activeIndex: null,
  label: 'Select an image',
  emptyStateProps: {},
};

Gallery.propTypes = {
  onChange: PropTypes.instanceOf(Function),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      fileName: PropTypes.string,
      fileSize: PropTypes.string,
      url: PropTypes.string,
    })
  ),
  activeIndex: PropTypes.number,
  label: PropTypes.string,
  emptyStateProps: PropTypes.instanceOf(Object),
};

export default Gallery;
